import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const Container = styled(CommonButton)(({ theme }) => ({
  paddingInlineEnd: '15rem',

  fontSize: theme.typography.size16,
}));
